import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import FormModal from 'components/app/common/FormModal';
import SoftwareLicenceService from './SoftwareLicenceService';
import schema from './jsonSchema';

const formatDate = inputDate => {
  const date = new Date(inputDate);
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };

  const formattedDate = date.toLocaleDateString('en-US', options);
  return formattedDate;
};

const SoftwareLicenceDetails = () => {
  const { identifier } = useParams();
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [event, setEvent] = useState();

  const showValue = attributeName => {
    return event[attributeName];
  };

  useEffect(() => {
    SoftwareLicenceService.retrieveSoftwareLicence(identifier)
      .then(data => {
        setEvent(data);
      })
      .catch(error => {
        console.error('Error retrieving SoftwareLicence', error);
      });
  }, []);

  const buttonsConf = [
    {
      name: 'Edit Software',
      type: 'button',
      variant: 'info',
      onClick: () => {
        console.log('Edit this SoftwareLicence');
        navigate('/app/software-licences/' + identifier + '/edit');
      }
    }
  ];

  const jsonSchema = schema;
  const headerGenerated = useHeaderGenerator(
    'Software Licence',
    ' ',
    buttonsConf
  );

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'SoftwareLicence has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
        />
      )}
      {event && (
        <>
          <Card>
            <Card.Body>
              {jsonSchema.map(field => {
                if (field.type === 'group') {
                  return field.fields.map(f => (
                    <Row key={f.name}>
                      <Col xs={5} sm={4}>
                        <p className="fw-semi-bold mb-1">{f.label + ': '}</p>
                      </Col>
                      <Col>{showValue(f.name)}</Col>
                    </Row>
                  ));
                } else {
                  return (
                    <Row key={field.name}>
                      <Col xs={5} sm={4}>
                        <p className="fw-semi-bold mb-1">
                          {field.label + ': '}
                        </p>
                      </Col>
                      <Col>{showValue(field.name)}</Col>
                    </Row>
                  );
                }
              })}
            </Card.Body>
          </Card>
        </>
      )}
    </>
  );
};

export default SoftwareLicenceDetails;
